import { Base } from "//www.greenwellfarms.com/cdn/shop/t/53/assets/base.js?v=169946323862693207411733340615";

/*
 * Product Single RC is a single dom that contains
 * product image, header, description, price, and over
 * link and a click button to go to product details
 * */

class ProductRCSingle extends Base{

    init(selector) {
        selector = this.prep_selector(selector, {classes: ["prc-single-wrapper", "glide__slide", "grid__item"]});
        this.set("el", selector);
        return this.prep();
    }

    prep(){

        let the_item = this.get("el"), 
            container = this.get_container(),
            prc_single_card = document.createElement("div"), 
            prc_single_media = document.createElement("div"), 
            prc_single_content = document.createElement("div"), 
            prc_single_info = document.createElement("div"), 
            media = document.createElement("div"), 
            media_button = document.createElement("div"), 
            el_image = document.createElement("img"), 
            el_title = document.createElement("h3"),
            el_description = document.createElement("div"), 
            el_price = document.createElement("div"), 
            media_link = document.createElement("a"),
            el_link = document.createElement("a"),
            link_button = document.createElement("button");

        // loading style here too
        prc_single_card.classList.add("prc-single-card");
        prc_single_media.classList.add("prc-single-media");
        prc_single_content.classList.add("prc-single-content");
        prc_single_info.classList.add("prc-single-infomation");
        media.classList.add("media");
        media_button.classList.add("media-button");
        el_image.classList.add("prc-single-image");
        el_title.classList.add("prc-single-title");
        el_description.classList.add("prc-single-desc");
        el_price.classList.add("prc-single-price");
        el_link.classList.add("prc-single-link");
        link_button.classList.add("link-button");
        media_link.classList.add("media-link");
        link_button.innerHTML = "Choose Options";

        the_item.el_image = el_image; 
        the_item.el_title = el_title;
        the_item.el_description = el_description;
        the_item.el_price = el_price;
        the_item.el_link = el_link;
        the_item.media_link = media_link;

        media_link.append(link_button);

        media_button.append(media_link);
        media.append(media_button);
        media.append(el_image);
        prc_single_media.append(media);

        prc_single_info.append(el_description);
        prc_single_info.append(el_price);
        prc_single_content.append(el_title);
        prc_single_content.append(prc_single_info);

        prc_single_card.append(prc_single_media);
        prc_single_card.append(prc_single_content);

        container.append(el_link);
        container.append(prc_single_card);

        return this.bind_events();

    }

    set title(value){this.get("el").el_title.innerHTML = value;}
    set_description(value){this.get("el").el_description.innerHTML = value;}
    set price(value){this.get("el").el_price.innerHTML = value;}
    set_link(value){
        this.get("el").el_link.href = value;
        this.get("el").media_link.href = value;
    }
    set image(value){
        this.get("el").el_image.src = value;
        this.get("el").el_image.alt = value;
        this.get("el").el_image.width = "100%";
    }

    bind_events(){

        return this;
    }

}

export { ProductRCSingle };
